var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccountVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d884d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33ad5e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-account-verified",
    transform: "translate(-875 -254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    transform: "translate(875 254)",
    fill: "none",
    stroke: "#5b5e6a",
    strokeWidth: 2,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 69,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_429",
    "data-name": "Ellipse 429",
    transform: "translate(884 263)",
    fill: "none",
    stroke: "#5b5e6a",
    strokeWidth: 2,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 61,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(892 271.455)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60490",
    "data-name": "Group 60490",
    transform: "translate(916.859 296.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34517",
    "data-name": "Path 34517",
    d: "M0,0H56.282V56.282H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34518",
    "data-name": "Path 34518",
    d: "M52.592,26.1,46.87,19.557l.8-8.653L39.2,8.981,34.769,1.5,26.8,4.924,18.823,1.5,14.39,8.981l-8.466,1.9.8,8.677L1,26.1l5.722,6.543-.8,8.677,8.466,1.923,4.432,7.5L26.8,47.3l7.973,3.424L39.2,43.243l8.466-1.923-.8-8.653L52.592,26.1Zm-9.263,3.471L42.016,31.1l.188,1.993.422,4.573L38.17,38.67l-1.97.446-1.032,1.735-2.322,3.94-4.174-1.806-1.876-.8-1.853.8L20.769,44.79l-2.322-3.916-1.032-1.735-1.97-.446L10.99,37.685l.422-4.6L11.6,31.1l-1.313-1.524L7.261,26.123l3.025-3.471L11.6,21.128l-.211-2.017-.422-4.549,4.456-1.008,1.97-.446,1.032-1.735,2.322-3.94L24.92,9.239l1.876.8,1.853-.8,4.174-1.806,2.322,3.94,1.032,1.735,1.97.446L42.6,14.562l-.422,4.573-.188,1.993,1.313,1.524L46.331,26.1l-3,3.471Z",
    transform: "translate(1.345 2.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34519",
    "data-name": "Path 34519",
    d: "M15.2,21.659,9.761,16.2,6.29,19.689,15.2,28.624l17.213-17.26L28.944,7.87Z",
    transform: "translate(8.461 10.586)",
    fill: "#ffbc5a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountVerified);
export default __webpack_public_path__ + "static/media/icon-account-verified.cea40dc52a81facfa69a100f78dddfd4.svg";
export { ForwardRef as ReactComponent };